import {createContext, useContext, useState, useCallback, useEffect} from "react";
import { AuthContext } from "./authContext";
import { API_BASE_URL, API_KEY } from "../config/config";
import axios from "axios";
import {useLocation, useParams} from "react-router-dom";

const CategoryContext = createContext(null);

const CategoryProvider = ({ children }) => {
	const { visitor } = useContext(AuthContext);

	const [categoryId, setCategoryId] = useState(null);

	const [categoryLoading, setCategoryLoading] = useState(false);
	const [category, setCategory] = useState(null);
	const [nodes, setNodes] = useState([]);
	const [nodeTree, setNodeTree] = useState([]);
	const [threadData, setThreadData] = useState([]);

	const fetchCategory = useCallback(async () => {
		if (!visitor) return;

		if (categoryLoading) return; // Loading

		if (category && category.node_id === categoryId) return; // Already loaded

		try {
			setCategoryLoading(true);

			const config = {
				method: "get",
				maxBodyLength: Infinity,
				url: `${API_BASE_URL}/categories/${categoryId}`,
				headers: {
					"XF-Api-Key": API_KEY,
					"XF-Api-User": visitor.user_id,
				},
				withCredentials: true,
			};

			const response = await axios.request(config);
			const fetchedCategory = response.data.category;
			setCategory(fetchedCategory);

			let nodeTree = response.data.tree_map;
			let nodes = response.data.nodes;

			if (typeof nodes === "object") {
				nodes = Object.values(nodes);
			}

			setNodeTree(nodeTree);
			setNodes(nodes);

			const threadData = response.data.threadData;
			setThreadData(threadData);

			setCategoryLoading(false);
		} catch (error) {
			console.error("Failed to fetch category:", error);
			setCategoryLoading(false);
		}
	}, [visitor, categoryLoading, categoryId]);

	const location = useLocation();
	const { categoryTitleId } = useParams();

	useEffect(() => {
		let path = location.pathname;
		path = path.replace(/^\/+|\/+$/g, "").trim();

		if (path === "gai-goi-ha-noi") {
			setCategoryId(8);
		} else if (path === "gai-goi-sai-gon") {
			setCategoryId(19);
		} else if (path === "gai-goi-thanh-pho-khac") {
			setCategoryId(32);
		} else if (categoryTitleId) {
			const urlPattern = /^([\w-]+)\.(\d+)$/;
			const match = categoryTitleId.match(urlPattern);
			if (match) {
				const [, , matchCategoryId] = match;
				setCategoryId(Number(matchCategoryId));
			}
		}

		if (category && categoryId && categoryId !== category.node_id) {
			setCategory(null);
		}
	}, [category, categoryTitleId, location.pathname]);

	return (
		<CategoryContext.Provider
			value={{
				fetchCategory,
				category,
				nodes,
				nodeTree,
				threadData,
				categoryLoading,
			}}
		>
			{children}
		</CategoryContext.Provider>
	);
};

export { CategoryContext, CategoryProvider };
